import { lessThanXDaysAgo, styles } from "@repo/helpers";
import { Col, Row } from "@repo/ui";

import { useEnrollmentValidationErrorApi } from "../../../../api/eveAPI";
import { useRepContext } from "../../../../contexts/editableItemContext";
import style from "./style.module.scss";

export function EVETypeGrid() {
	const { repId } = useRepContext();
	const { useEVEsQuery } = useEnrollmentValidationErrorApi();
	const { data } = useEVEsQuery(repId);

	if (!data?.count()) return null;

	const recentComplaints = data.data.filter((c) => lessThanXDaysAgo(c.createdOn, 90) && c.valid !== false);

	if (!recentComplaints.length) return null;

	const filteredComplaints = recentComplaints.filter((d) => d.validationName !== null);
	const groupedComplaints = Array.from(filteredComplaints.groupBy((d) => d.validationName).entries() || []);
	const totalComplaints = groupedComplaints.map((g) => g[1]).flat().length;

	return (
		<>
			<hr />
			<Row className={styles(style.tableHeader, style.tableRow)}>
				<Col className={style.tableCell} lg={12}>
					<span>Validation Errors - Last 90 Days</span>
					<span>Count</span>
				</Col>
			</Row>
			{renderDataRows()}
			<Row className={styles(style.tableFooter, style.tableRow)}>
				<Col className={style.tableCell} lg={12}>
					<span>Grand Total</span>
					<span>{totalComplaints}</span>
				</Col>
			</Row>
		</>
	);

	function renderDataRows() {
		function renderRow(group) {
			const [name, list] = group;
			return (
				<Row key={name} className={style.tableRow}>
					<Col className={style.tableCell} lg={12}>
						<span>{name}</span>
						<span>{list.length}</span>
					</Col>
				</Row>
			);
		}

		return groupedComplaints.map(renderRow);
	}
}
